import React from 'react';
import Container from '../../../../UI/LAYOUT/CONTAINER/Container';
import { Controller, useForm } from 'react-hook-form';
import { TextField } from '@mui/material';
import { useRecoilValue } from 'recoil';
import userInfoAtom from '../../../../recoil/atom/login/userInfoAtom';
import { useMutation } from '@tanstack/react-query';
import { setInquiry } from '../../../../api/Dojang/dojangApi';
import dojangIdAtom from '../../../../recoil/atom/dojangIdAtom';
import { useIntl } from 'react-intl';
import PrimaryButton from '../../../../UI/ATOM/BUTTON/PrimaryButton';
import { useNavigate } from 'react-router-dom';

const ServiceInquiry = () => {
  const nav = useNavigate();

  // intl
  const intl = useIntl();

  // recoil
  const user = useRecoilValue(userInfoAtom);
  const dojangId = useRecoilValue(dojangIdAtom);

  // query - set
  const { mutate, isLoading } = useMutation((body) => setInquiry(dojangId, body));

  // form
  const { control, handleSubmit } = useForm({
    defaultValues: {
      email: user?.username,
    },
  });

  // submit
  const onSubmit = (v) => {
    // email error
    if (!v?.email) return alert(intl.formatMessage({ id: 'errMsg' }));

    // mutate
    mutate(v, {
      onSuccess: (res) => {
        alert(
          'Your inquiry has been successfully submitted.\nWe will get back to you via email after reviewing it.\nThank you.',
        );
        nav('/home');
      },
      onError: (err) => {
        console.log(err);
        alert(intl.formatMessage({ id: 'errMsg' }));
      },
    });
  };

  return (
    <Container title={'Inquiry'}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className='w-[800px] flex flex-col gap-6 bg-white p-10 rounded-lg shadow-sm'>
          {/* 안내 문구 */}
          <div className='text-sm text-gray-700 bg-gray-100 px-5 py-4 rounded-md border border-gray-300 leading-relaxed'>
            Your inquiry will be reviewed, and we’ll get back to you at{' '}
            <strong className='text-black'>{user?.username ?? ''}</strong> within a few days.
          </div>

          {/* Subject */}
          <Controller
            name='subject'
            control={control}
            rules={{
              required: 'Subject is required.',
              maxLength: {
                value: 50,
                message: 'Subject must be 50 characters or less.',
              },
            }}
            render={({ field, fieldState: { error } }) => (
              <TextField
                label='Subject'
                placeholder='Subject must be 50 characters or less.'
                fullWidth
                variant='outlined'
                {...field}
                error={!!error}
                helperText={error?.message}
              />
            )}
          />

          {/* Message */}
          <Controller
            name='message'
            control={control}
            rules={{
              required: 'Message is required.',
              maxLength: {
                value: 1000,
                message: 'Message must be 1000 characters or less.',
              },
            }}
            render={({ field, fieldState: { error } }) => (
              <TextField
                label='Message'
                placeholder='Message must be 1000 characters or less.'
                fullWidth
                multiline
                minRows={10}
                variant='outlined'
                {...field}
                error={!!error}
                helperText={error?.message}
              />
            )}
          />

          {/* Submit button */}
          <div className='flex justify-end'>
            <PrimaryButton
              type='submit'
              variant='contained'
              color='primary'
              className='mt-2'
              loading={isLoading}
            >
              Submit
            </PrimaryButton>
          </div>
        </div>
      </form>
    </Container>
  );
};

export default ServiceInquiry;
